















































import { isEmpty } from 'lodash-es';
import { defineComponent, ref, useFetch, useContext, onMounted } from '@nuxtjs/composition-api'
import { PropType } from 'vue';
import { ProductForProductPageType } from '~/utils/types/ProductPage';
import { useCategoryStore } from '~/modules/catalog/category/stores/category';
import { getIsBook, getProductTypeTag } from '~/utils/solepro/products';
import { getFirstProLabel, getSecondProLabel, getLowestMetaPrice } from '~/utils/helpers/product';
import { productBuyCTATrack, productFreeCTATrack } from '~/helpers/trackings/24orepro/products';
import HTMLContent from '~/components/solepro/HTMLContent.vue';
import { productTypeTag } from '~/utils/types/Product';

export default defineComponent({
   props: {
        product: {
            type: Object as PropType<ProductForProductPageType>
        }
    },
    components:{
      HTMLContent
    },
    setup(props) {
      const { product } = props || {};
      const { app: { i18n }, $fc } = useContext();
      const allCategories = ref([]);
      const productTag = ref({} as productTypeTag);
      const categoryStore = useCategoryStore();
      const freeLink = ref(product?.freeDemoURL ?? "");
      const firstLabel = ref<String>("");
      const secondLabel = ref<String>("");

      /**
       * @hot - Questo è solo per i non-libri, da testare poi con i libri se si rompe.
       * @todo: Occhio, qui manca la gestione delle demo, mancano ancora gli attributi.
       */


      const targetProduct = !isEmpty(product.additionalProducts) ? 
         getLowestMetaPrice(product.additionalProducts) : product;

      const lowFrequencySpan = targetProduct.paymentFrequencies[0];
      
      /** 
       * Check if frequencySpan exist, instead, use simple price with currency converter.
      */
     onMounted(()=>{
         const varLength = (Array.from(document.querySelectorAll('.solepro-option-card')).length > 1) || (!!product.variants && product.variants.length > 1); // @TODO fare il conteggio in maniera decente); // @TODO fare il conteggio in maniera decente
         if (lowFrequencySpan) {
           firstLabel.value = getFirstProLabel(targetProduct, lowFrequencySpan, i18n, $fc, null, varLength);
           secondLabel.value = getSecondProLabel(targetProduct, lowFrequencySpan, i18n, $fc, varLength);
        } else {
           firstLabel.value = `${$fc(targetProduct.price)}`;
        }
     })
      
      const trackProductFreeCTA = async () => await productFreeCTATrack(product);
   

      useFetch(async () => {        
            await categoryStore.load();
            allCategories.value = categoryStore.rawCategories?.items[0].children;
            productTag.value = getProductTypeTag(allCategories.value, product);
        });

        const hasOnlyBuyable = product.additionalProducts && product.additionalProducts.length>0 
        ? product.additionalProducts.every(p=>p.buyable) : product.buyable; 
        const hasSomeBuyable = product.additionalProducts && product.additionalProducts.length>0 
        && product.additionalProducts.some(p=>p.buyable);

      return {
         productTag,
         firstLabel,
         secondLabel,
         trackProductFreeCTA,
         freeLink,
         isBook: getIsBook(product),
         hasOnlyBuyable,
         hasSomeBuyable
      }

    },
    methods:{
      async manageScroll(evt){
         try {
            const id = evt.target.href.split('#')[1];
            document.getElementById(id).scrollIntoView()
            await productBuyCTATrack(this.product);
         } catch(e){
            console.error(e)
         }
      }
   },
})
